import React from "react";
import { MdOutlineAddCircle } from "react-icons/md";
import { HiMicrophone } from "react-icons/hi2";

import type { SmsFooterProps } from "../types";

export const SmsFooter = ({ message, isInitPreview }: SmsFooterProps) => {
  return (
    <div className="sms-preview__content">
      <div className="sms-preview__content-container">
        <div
          className="sms-preview__add-icon"
          role="img"
          aria-label="Add attachment"
        >
          <MdOutlineAddCircle />
        </div>

        <div className="sms-preview__message-container">
          <div className="sms-preview__message-text">
            <p
              className={`sms-preview__message ${isInitPreview ? "sms-preview__message--init" : ""}`}
              aria-label="SMS message"
            >
              {message}
            </p>
          </div>

          <div
            className="sms-preview__voice"
            role="img"
            aria-label="Voice message"
          >
            <HiMicrophone />
          </div>
        </div>
      </div>
    </div>
  );
};
